/**
 * Layer Type: HP2 Hexagons
 *
 * @package  embark
 * @since    1.0.0
 */

// Function to update the scaling for all path elements with the "scaled-path" class.
function updatePathScaling(elementToScale, elementWithLinks) {
	const windowWidth = window.innerWidth;
	const viewBoxWidth = 1117; // this is the width of the svg mask.
	let scaleFactor = windowWidth / viewBoxWidth;

	// Get all path elements with the provided selector.
	const pathElements = document.querySelectorAll(elementToScale);

	// For smaller screen sizes apply fixed scale factor, to match designs (mobile).
	if (windowWidth < 575) {
		scaleFactor = 575 / viewBoxWidth;
	}

	// Check if screen width is smaller than svg viewBox width and element exist in the DOM.
	if (windowWidth < viewBoxWidth && pathElements.length > 0) {
		// Get the SVG element with the provided ID.
		const svgElementWithLinks = document.getElementById(elementWithLinks);

		// Apply the scaling factor to each path element.
		pathElements.forEach((pathElement) => {
			pathElement.setAttribute('transform', `scale(${scaleFactor})`);
		});

		// Check if the SVG element with links is in the DOM.
		if (svgElementWithLinks) {
			// Find all <text> elements within the SVG element.
			const textElements = svgElementWithLinks.querySelectorAll('text');

			// Apply the scaling factor to each <text> element.
			textElements.forEach((textElement) => {
				textElement.setAttribute('transform', `scale(${scaleFactor})`);
			});
		}
	}
}

// Custom scale ratio for specific screen size between 1200px and 1599px.
function getCustomScaleRatio(screenWidth, minValue, maxValue) {
	const minWidth = minValue; // The smaller screen width.
	const maxWidth = maxValue; // The larger screen width.
	const minScale = 0.65; // Scale at minWidth.
	const maxScale = 1; // Scale at maxWidth.

	// Calculate the scale ratio using linear interpolation.
	const scale = minScale + ((maxScale - minScale) * (screenWidth - minWidth)) / (maxWidth - minWidth);

	// Ensure the scale doesn't go below the minimum scale.
	return Math.max(minScale, scale);
}

// Scale elements between viewport range.
function scaleElementsForViewportRange(selector, minViewport, maxViewport) {
	const windowWidth = window.innerWidth;

	if (selector) {
		if (windowWidth > minViewport && windowWidth < maxViewport) {
			// Apply the style to each element.
			selector.forEach((element) => {
				element.style.transform = `scale(${getCustomScaleRatio(windowWidth, minViewport, maxViewport)})`;
			});
		} else {
			// Remove specific style to each element.
			selector.forEach((element) => {
				element.style.transform = 'none';
			});
		}
	}
}

function scaleHeroVisualInScreenRange(selector, minScreenSize, maxScreenSize) {
	// Find elements that needs to be scaled on specific screen size.
	const elementsToBeScaled = document.querySelectorAll(selector);

	if (elementsToBeScaled.length > 0) {
		scaleElementsForViewportRange(elementsToBeScaled, minScreenSize, maxScreenSize);
	}
}

// Adjust SVG Attributes. Used for Section Tabs with Hexagons.
function adjustSVGAttributes() {
	const svgElement = document.querySelector('.hp2-tabs__svg');

	if (svgElement) {
		if (window.innerWidth < 1200) {
			svgElement.setAttribute('height', '606');
			svgElement.setAttribute('viewBox', '0 0 942 606');
		} else {
			svgElement.setAttribute('height', '816');
			svgElement.setAttribute('viewBox', '0 0 942 816');
		}
	}
}

// Adjust SVG Parent Height.
function adjustSVGParentHeight() {
	const parentElements = document.querySelectorAll('.hp2-tabs__visual');

	if (parentElements) {
		parentElements.forEach((parentElement) => {
			const svgElement = parentElement.querySelector('.hp2-tabs__svg');
			if (svgElement) {
				// Get its bounding box.
				const svgBoundingBox = svgElement.getBoundingClientRect();
				const svgBoundingBoxHeight = svgBoundingBox.height;

				if (window.innerWidth > 1200 && window.innerWidth < 1580) {
					parentElement.style.height = `${svgBoundingBoxHeight}px`;
				} else {
					// remove height if conditions are not met.
					parentElement.style.height = '';
				}
			}
		});
	}
}

// Get the SVG element.
const homeTabsSvgElement = document.querySelector('.hp2-tabs__svg');

// Pause the animation (helper function).
function emSvgPauseAnimation(element) {
	// Check if element and pauseAnimations method are available before execute the code.
	if (element && element.pauseAnimations) {
		element.pauseAnimations();
	}
}

// Handle when SVG animation should be triggered (when element is in screen viewport).
function emHomeSvgAnimationTriggerInViewPort(element) {
	// Function to be called when the element is in the viewport.
	function handleIntersection(entries, observer) {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				// Element is in the viewport, resume the animation.
				element.unpauseAnimations();
				// Stop observing once the animation is resumed (optional).
				observer.disconnect();
			}
		});
	}

	// Check if element and unpauseAnimations method are available before execute the code.
	if (element && element.pauseAnimations) {
		// Create an Intersection Observer instance.
		const emSvgAnimationObserver = new IntersectionObserver(handleIntersection, { threshold: 0.5 });

		// Start observing the SVG element.
		emSvgAnimationObserver.observe(element);
	}
}

// Run the script when Dom Content is loaded.
window.addEventListener('DOMContentLoaded', () => {
	updatePathScaling('.scaled-path', 'svgLinks');
	scaleHeroVisualInScreenRange('.hp2-hero-hex-mask', 1200, 1599);
	scaleHeroVisualInScreenRange('.hp2-tabs__svg', 1200, 1599);
	adjustSVGAttributes();
	adjustSVGParentHeight();
	emSvgPauseAnimation(homeTabsSvgElement);
	emHomeSvgAnimationTriggerInViewPort(homeTabsSvgElement);
});

// Update the scaling when the window is resized.
window.addEventListener('resize', () => {
	updatePathScaling('.scaled-path', 'svgLinks');
	scaleHeroVisualInScreenRange('.hp2-hero-hex-mask', 1200, 1599);
	scaleHeroVisualInScreenRange('.hp2-tabs__svg', 1200, 1599);
	adjustSVGAttributes();
	adjustSVGParentHeight();
});
